import {
  Chat as ChatIcon,
  Event as EventIcon,
  Folder as ResourcesIcon,
  Groups as GroupsIcon,
} from "@mui/icons-material";
import { Grid } from "@mui/material";

import { ActivityCard } from "~ui/atoms/ActivityCard/ActivityCard";

export interface RoomActivityCardsProps {
  memberCount: number;
  eventCount: number;
  resourceCount: number;
  chatMemberCount: number;
  onMembersClick?: () => void;
  onEventsClick?: () => void;
  onResourcesClick?: () => void;
  onChatClick?: () => void;
}

export const RoomActivityCards = ({
  memberCount,
  eventCount,
  resourceCount,
  chatMemberCount,
  onMembersClick,
  onEventsClick,
  onResourcesClick,
  onChatClick,
}: RoomActivityCardsProps) => {
  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid
        size={{
          md: 3,
          sm: 6,
          xs: 12,
        }}
      >
        <ActivityCard
          title="Members"
          count={memberCount}
          icon={<GroupsIcon />}
          color="primary"
          onClick={onMembersClick}
        />
      </Grid>
      <Grid
        size={{
          md: 3,
          sm: 6,
          xs: 12,
        }}
      >
        <ActivityCard title="Events" count={eventCount} icon={<EventIcon />} color="success" onClick={onEventsClick} />
      </Grid>
      <Grid
        size={{
          md: 3,
          sm: 6,
          xs: 12,
        }}
      >
        <ActivityCard
          title="Resources"
          count={resourceCount}
          icon={<ResourcesIcon />}
          color="info"
          onClick={onResourcesClick}
        />
      </Grid>
      <Grid
        size={{
          md: 3,
          sm: 6,
          xs: 12,
        }}
      >
        <ActivityCard
          title="Chat"
          count={chatMemberCount}
          icon={<ChatIcon />}
          color="secondary"
          onClick={onChatClick}
        />
      </Grid>
    </Grid>
  );
};
